import Vue from 'vue'
import App from './app.vue'
import router from './router'
import ElementUI from 'element-ui';
import HxNotify from '@/common/hx-notify'
import site from '@/common/site'
import store from "../../store";

import VueAweSomeSwiper from 'vue-awesome-swiper'//轮播图
import 'swiper/dist/css/swiper.css'

Vue.use(VueAweSomeSwiper)


import '@/assets/css/common.scss'

Vue.prototype.$filePath = process.env.VUE_APP_FILE_URL

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$notify = HxNotify
Vue.prototype.$site = site

new Vue({
    router,
    el: '#app',
    store,
    render: h => h(App)
})
